<template>
  <auth-layout>
    <div class="logo-wrapper d-flex justify-content-center">
      <img
        src="@/assets/images/onboarding/complete.png"
        alt="onboarding complete"
      />
    </div>
    <!-- <div class="onboarding__img-wrapper d-flex justify-content-center">
      <img
        src="@/assets/images/onboarding/man-pushing-cart.png"
        class="img-responsive onboarding_img"
        alt="Illustration of a man pushing a cart"
      />
    </div> -->
    <div class=" text-darkBlue text-center">
      <h1 class="text-3xl font-bold">
        Basic Set Up Complete
      </h1>
      <p class="text-sm w-4/5 mx-auto">
        Done! You have successfully set up your MuleEx Dashboard. You can always
        update these settings in your Dashboard Settings.
      </p>
    </div>
    <div class="flex justify-center mt-6">
      <router-link to="/login">
        <base-button text="Go to Login" p="px-6 py-2" />
      </router-link>
    </div>
  </auth-layout>
</template>

<script>
import toastGenerator from "../../mixins/toastGenerator";
import AuthLayout from "../Auth/Authlayout/OnDemand";
export default {
  components: { AuthLayout },
  mounted() {
    this.generateToast("Registration Complete!", "success");
  },
  mixins: [toastGenerator],
};
</script>

<style scoped>
.logo-wrapper {
  padding: 1.5rem 0;
}
.onboarding__img-wrapper {
  padding: 1rem;
}
</style>
